import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import WidgetsIcon from '@material-ui/icons/Widgets';
import BookIcon from '@material-ui/icons/Book';

export default [
  { to: '/', text: 'Home', Icon: <HomeIcon /> },
  { to: '/membership', text: 'Our Membership', Icon: <CardMembershipIcon /> },
  { to: '/achievement', text: 'Live Achievement', Icon: <LocalLibraryIcon /> },
  { to: '/blog', text: 'Blog', Icon: <WidgetsIcon /> },
  { to: '/hub', text: 'Knowledge Hub', Icon: <BookIcon /> },
];
